import { Error } from './Error';
import { Info } from './Info';
import { Success } from './Success';
import { Warning } from './Warning';

/**
 * @deprecated use `Alert` instead
 * @example <Alert variant="information">
 *            content
 *          </Alert>
 */
export const Message = Object.assign(Info, {
  /**
   * @deprecated use `Alert` instead
   * @example <Alert variant="information">
   *            content
   *          </Alert>
   */
  Info,
  /**
   * @deprecated use `Alert` instead
   * @example <Alert variant="error">
   *            content
   *          </Alert>
   */
  Error,
  /**
   * @deprecated use `Alert` instead
   * @example <Alert variant="success">
   *            content
   *          </Alert>
   */
  Success,
  /**
   * @deprecated use `Alert` instead
   * @example <Alert variant="warning">
   *            content
   *          </Alert>
   */
  Warning,
});
